// ============================================================
// CustomerFormOverlay — Kunden-Formular des Voice-Pfads (React-Insel).
// Ersetzt #ab-cust-overlay aus AssistantBar.js; Prefill/Status kommen aus
// der Engine (open_customer_form → showCustomerForm), CSS unverändert.
// ============================================================
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from '../../lib/useTranslation.ts';
import type { AssistantEngine } from '../../../components/assistant-bar/engine/AssistantEngine.ts';

function CustomerFormBody({ engine }: { engine: AssistantEngine }) {
  const t = useTranslation();
  const p = engine.custForm?.prefill || {};
  const [name, setName] = useState(p.name || '');
  const [phone, setPhone] = useState(p.phone || '');
  const [street, setStreet] = useState(p.street || '');
  const [plz, setPlz] = useState(p.postalCode || '');
  const [city, setCity] = useState(p.city || '');
  const [email, setEmail] = useState(p.email || '');
  const nameRef = useRef<HTMLInputElement | null>(null);

  // Fokus 250 ms nach dem Öffnen (wie im alten showCustomerForm).
  useEffect(() => {
    const timer = setTimeout(() => { try { nameRef.current?.focus(); } catch { /* wie zuvor */ } }, 250);
    return () => clearTimeout(timer);
  }, []);

  const create = () => engine.createCustomerNow({ name, phone, street, plz, city, email });

  return (
    <div className="ab-cust-box">
      <div className="ab-cust-title">{t('assistant.newCustomer')}</div>
      <label className="ab-cust-label"><span>{t('common.name')}</span><input ref={nameRef} className="ab-cust-input" id="ab-cust-name" type="text" autoComplete="off" value={name} onChange={(e) => setName(e.target.value)} /></label>
      <label className="ab-cust-label"><span>{t('assistant.phone')}</span><input className="ab-cust-input" id="ab-cust-phone" type="tel" inputMode="tel" autoComplete="off" placeholder="0791234567" value={phone} onChange={(e) => setPhone(e.target.value)} /></label>
      <label className="ab-cust-label"><span>{t('assistant.street')}</span><input className="ab-cust-input" id="ab-cust-street" type="text" autoComplete="off" placeholder="Bahnhofstrasse 12" value={street} onChange={(e) => setStreet(e.target.value)} /></label>
      <div className="ab-cust-row">
        <label className="ab-cust-label ab-cust-plz"><span>{t('assistant.plz')}</span><input className="ab-cust-input" id="ab-cust-plz" type="text" inputMode="numeric" autoComplete="off" placeholder="8001" value={plz} onChange={(e) => setPlz(e.target.value)} /></label>
        <label className="ab-cust-label ab-cust-ort"><span>{t('assistant.city')}</span><input className="ab-cust-input" id="ab-cust-city" type="text" autoComplete="off" placeholder="Zürich" value={city} onChange={(e) => setCity(e.target.value)} /></label>
      </div>
      <label className="ab-cust-label"><span>{t('assistant.email')}</span><input className="ab-cust-input" id="ab-cust-email" type="email" inputMode="email" autoComplete="off" autoCapitalize="off" spellCheck={false} placeholder="name@example.com" value={email} onChange={(e) => setEmail(e.target.value)} /></label>
      <div className="ab-email-actions">
        <button className="ab-email-cancel" id="ab-cust-cancel" onClick={() => engine.hideCustomerForm()}>{t('common.cancel')}</button>
        <button className="ab-email-send" id="ab-cust-create" onClick={create}>{t('common.create')}</button>
      </div>
      <div className="ab-email-status" id="ab-cust-status">{engine.custForm?.status || ''}</div>
    </div>
  );
}

export function CustomerFormOverlay({ engine }: { engine: AssistantEngine }) {
  const form = engine.custForm;
  if (!form) return null;
  return (
    <div
      className="ab-cust-overlay"
      id="ab-cust-overlay"
      style={{ display: 'flex' }}
      onClick={(e) => { if (e.target === e.currentTarget) engine.hideCustomerForm(); }}
    >
      {/* key=seq: jedes showCustomerForm startet mit frischem Prefill */}
      <CustomerFormBody key={form.seq} engine={engine} />
    </div>
  );
}
